import React, { useEffect, useState } from 'react';
import { List, Typography, Spin ,Card} from 'antd';
import { fetchArticlesService, fetchRecentArticlesService,fetchApprovedArticlesService,fetchPublicArticlesService } from '../../services/ArticleService'; // Service to fetch the last 5 articles
import { Link } from 'react-router-dom';

const { Text } = Typography; // Import Paragraph for multi-line text

const RecentArticlesList = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false); // Loading state
  

  useEffect(() => {
    const auth = localStorage.getItem('authToken') !== null;
      setAuth(auth);
      console.log(auth);
      const loadRecentArticles = async () => {
        try {
          // 1. Fetch all articles based on auth status
          const allArticles = auth 
            ? await fetchApprovedArticlesService() 
            : await fetchPublicArticlesService();
          
          // 2. Sort the articles by 'createdAt' date, newest first
          const sortedArticles = [...allArticles].sort((a, b) => {
            // Compare dates directly
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
  
          // 3. Get only the top 10 articles
          const recentArticles = sortedArticles.slice(0, 10);
  
          // 4. Set the state with just the top 10
          setArticles(recentArticles);
  
        } catch (error) {
          console.error('Failed to load recent articles', error);
        } finally {
          setLoading(false);
        }
      };
  
      loadRecentArticles();
  }, []);

  if (loading) {
    return <Spin tip="Loading recent articles..." />;
  }

  return (
    <Card 
      title="Recent Articles" 
      bordered={false} 
      style={{ background: '#fff', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
    >
      <List
        itemLayout="vertical"
        dataSource={articles}
        renderItem={(article) => (
          <List.Item key={article.id}>
            <Link to={`/articles/${article.id}`} style={{ display: 'block' }}> 
              <div style={{ display: 'flex' }}>
                {/* Article Image - Use align-items: flex-start to align with the top line */}
                <img
                  src={
                    article.coverUrl != null && article.coverUrl !== ""
                      ? article.coverUrl
                      : '/default.jpg'
                  }
                  alt={article.title}
                  style={{ width: '80px', height: '80px', objectFit: 'cover', marginRight: '10px', borderRadius: '4px', flexShrink: 0 }} // flexShrink: 0 prevents it from shrinking
                />
                
                {/* Article Content */}
                <div style={{ flexGrow: 1, minWidth: 0 }}> 
                  {/* 1. FULL TITLE - Allow wrapping */}
                  <div style={{ marginBottom: '4px' }}>
                    <Text strong style={{ display: 'block' }}>{article.title}</Text>
                  </div>

                  <Text type="secondary" style={{ fontSize: '0.85em' }}>
                    {new Date(article.createdAt).toLocaleDateString()}
                  </Text>
                </div>
              </div>
            </Link>
          </List.Item>
        )}
      />
    </Card>
  );


};

export default RecentArticlesList;
